

<nav class="navbar fixed-top navbar-expand-lg bg-white border-bottom">
    <div class="container">
        <!-- <a class="navbar-brand p-0" href="index.html"><img class="pr-3" src="img/logo.jpg"></a> -->
        <a class="navbar-brand p-0" href=""><img class="pr-3" src="assets/img/logo.jpg"></a>
    </div>
</nav>



<div id="campaign-top-banner">
	  <div class="overlay"></div>
      <div class="container pt-4">
        <div class="row">
          <div class="col-md-7 header-txt">
            <h1 class="h2">OMNI is the world's first upskilling platform for enterprise AI-RPA skills.</h1>
            <a  href="jvascript:void(0);" (click)="scrollFn('fill-form')" class="bg-button btn btn-primary mt-4"> Interested? Know more<!--<i class="fas fa-chevron-right"></i>--></a>
            
          </div>
        </div>
      </div>
</div>

<div id="fill-form" class="bg-grey pt-0">
      <div class="container py-5">
        <div class="row">
          <div class="col-md-5 text-justify pr-md-5">
            
            <div class="orange-text mb-2">
            	<span class="h4 text-left mr-2">Rating</span>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
          </div>
            <p>OMNI helps CXOs in solving the AI-RPA skilling challenge – one citizen developer at a time. It is the world' s first and only value-added aggregator of top-tier AI-RPA platforms – enabling business users to get trained and evaluate any platform of their choice. In addition, OMNI offers more than 1,000+ pre-loaded bots and POCs. There is no need to procure these tools or dedicate servers or find datasets for your POC's, our sandbox enables you to do this, and lot more.</p>
            <p>With OMNI, your citizen developers can build bots in any pre-loaded major platform of their choice, so you can TRY before you BUY and avoid any misaligned technology choices that may lead to problems in the future.</p>
          </div>
          
          
        
          <div class="col-md-7 form-bg bg-white p-4 mt-2 mb-5">
          	  <p class="h3 text-center ">Talk to us</p>
              <p class="text-center pb-2">We will be happy to support your journey to the AI-RPA enterprise of the future.</p>
              <form>
                  <div class="row">                                
                      <div class="col-md-6 mb-4">
                          <input class="search form-control pl-3" type="text" placeholder="Name">
                      </div>
                      <div class="col-md-6 mb-4">
                          <input class="search form-control pl-3" type="text" placeholder="Email*">
                      </div>
                  </div>   
                  
                  <div class="row">                                
                     
                      <div class="col-md-6 mb-4">
                          <input class="search form-control pl-3" type="text" placeholder="Company Name">
                      </div>
                      <div class="col-md-6 mb-4">
                          <input class="search form-control pl-3" type="text" placeholder="Job Title">
                      </div>
                      
                  </div>                        
                   <p class="small mt-2 text-center">By sharing your details, you agree with OMNI's <a href="https://app.omnicoe.com/tnc" target="_blank" class="active">terms of use</a> and <a href="https://app.omnicoe.com/tnc" target="_blank" class="active">privacy policy</a>.</p>
                  <div class="pt-4 text-center">
                      <a  href="https://calendly.com/omnidemo" target="_blank" class="bg-button btn btn-primary bd-highlight">Submit</a>
                      
                  </div>
              </form>
          </div>
          
        </div>
      </div>
</div>


<footer class="container">
	
    <hr>
    <div class="row">
    	<div class="col-md-12 text-center"><p>© 2021 <a href="https://www.airodigitallabs.com/" target="_blank">AiRo Digital Labs.</a> All right reserved.</p></div>
    </div>
</footer>

